import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputInscricaoEstadual = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { state_insc } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("state_insc")
    }

    return (
        <CampoInputTexto
            id="inputInscricaoEstadual"
            titulo="Inscrição estadual"
            onChange={handleChange}
            name="state_insc"
            value={state_insc}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputInscricaoEstadual
